/**
 * Why an open silence ("dead air") happened during a live customer interaction. Derived from real
 * research into what agents are actually doing when they go quiet.
 *
 * The first three are "fillable": the assistant can potentially supply the answer the agent is
 * reaching for and remove the silence. The rest describe silences an assistant should not try to
 * fill (a transfer is underway, the agent explicitly put the customer on hold, the customer is
 * performing a physical step on their device, the customer stepped away, or the reason is unclear).
 */
export type DeadAirCategory =
    | "LOOKUP_STALL"
    | "RE_ASK"
    | "SYSTEM_NAV"
    | "TRANSFER_ESCALATION"
    | "HOLD_STATED"
    | "DEVICE_STEP_WAIT"
    | "CUSTOMER_ABSENT"
    | "AWKWARD_UNKNOWN";

/**
 * The model's structured verdict on an open silence. `answer` is non-null ONLY when the model is
 * confident it can fill the silence for a fillable category.
 */
export interface DeadAirClassification {
    category: DeadAirCategory;
    confidence: number; // 0..1
    answer: string | null;
}

/** All eight categories, in taxonomy order. Used for runtime validation of model output. */
export const DEAD_AIR_CATEGORIES: readonly DeadAirCategory[] = [
    "LOOKUP_STALL",
    "RE_ASK",
    "SYSTEM_NAV",
    "TRANSFER_ESCALATION",
    "HOLD_STATED",
    "DEVICE_STEP_WAIT",
    "CUSTOMER_ABSENT",
    "AWKWARD_UNKNOWN",
];
